import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { PaginatedTableEvent } from './paginated-table/paginated-table.component'

export type SortDirection = 'asc' | 'desc'
export type ListParameterQuery = {
  page: number
  pageSize: number
  sortField?: string
  sortDirection?: SortDirection
}

export type ListParameterQueryOptional = Partial<ListParameterQuery>

export function constructQueryParameterName(key: string, prefix: string | null, postFix: string | null = null): string {
  if (prefix === null) {
    return key
  }
  return `${prefix}${key.charAt(0).toUpperCase()}${key.slice(1)}${postFix !== null ? `.${postFix}` : ''}`
}

// TODO properly type and handle undefined/null values
export function getPaginationOptionsFromQueryParamMap(queryParamMap: ParamMap, prefix: string | null = null, defaults: ListParameterQueryOptional = {}) {
  const page = queryParamMap.has(constructQueryParameterName('page', prefix))
    ? parseInt(queryParamMap.get(constructQueryParameterName('page', prefix))!)
    : (defaults?.page ?? 0)
  const pageSize = parseInt(queryParamMap.get(constructQueryParameterName('pageSize', prefix)) ?? defaults?.pageSize?.toString() ?? '100')
  const sortField = queryParamMap.get(constructQueryParameterName('sortField', prefix)) ?? defaults?.sortField ?? null
  const sortDirection = queryParamMap.get(constructQueryParameterName('sortDirection', prefix)) ?? (defaults?.sortDirection as SortDirection) ?? null
  return {
    page,
    pageSize,
    sortField,
    sortDirection,
  }
}

export async function emitOrderBy(router: Router, route: ActivatedRoute, sortField: string, sortDirection = 'ASC', prefix: string | null = null) {
  await router.navigate([], {
    queryParams: {
      [constructQueryParameterName('sortField', prefix)]: sortField,
      [constructQueryParameterName('sortDirection', prefix)]: sortDirection,
    },
    queryParamsHandling: 'merge',
    relativeTo: route,
  })
}

export function emitPaginationQueryParameterChanges(router: Router, route: ActivatedRoute, event: PaginatedTableEvent, prefix: string | null = null) {
  router.navigate([], {
    queryParams: {
      [constructQueryParameterName('page', prefix)]: event.page,
      [constructQueryParameterName('pageSize', prefix)]: event.pageSize,
      [constructQueryParameterName('sortField', prefix)]: event.sortField,
      [constructQueryParameterName('sortDirection', prefix)]: event.sortDirection,
    },
    queryParamsHandling: 'merge',
    relativeTo: route,
  })
}
